// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sidebar-subtitle[data-v-3d7cc956]{color:var(--color-text-lighter);display:flex;gap:0 12px}`, "",{"version":3,"sources":["webpack://./components/SidebarSubtitle.vue"],"names":[],"mappings":"AACA,mCACE,+BAAA,CACA,YAAA,CACA,UAAA","sourcesContent":["\n.sidebar-subtitle {\n  color: var(--color-text-lighter);\n  display: flex;\n  gap: 0 12px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
